export const CHALLENGE = 'CHALLENGE';
export const QUIZ = 'QUIZ';
export const CEFR_LEVEL_TEST = 'CEFR_TEST';
